module.exports = __webpack_public_path__ + "img/waiting-on-photo@3x.4e3d5303.webp";